import colors, { ratingColors } from 'config/theme/colors';

export const getTagColor = (key: string) => {
  if (!Object.hasOwn(ratingColors, key)) {
    return colors.platinum;
  }
  return ratingColors[key];
};
